/*
 * APIM Interceptor
 * This interceptor attaches APIM access token to protected resources except APIM token APIs
 */

import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { PopupService } from '../modules/popup/services/popup.service';
import { AuthService } from '@shared/services/auth.service';

import { CustomHttpParams } from '@shared/services/api.service';

import { ToastService } from '@shared/modules/toast/services/toast.service';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';
import { trigger } from '@angular/animations';

@Injectable()
export class APIMInterceptor implements HttpInterceptor {
  private readonly baseURLConfig: any;
  private readonly authConfig: any;
  private readonly APIMConfig: any;
  constructor(
    private popupService: PopupService,
    private authService: AuthService,
    private toastService: ToastService,
    private runTimeConfigService: RunTimeConfigService
  ) {
    this.baseURLConfig = this.runTimeConfigService.getConfig('baseURLConfig');
    this.authConfig = this.runTimeConfigService.getConfig('authConfig');
    this.APIMConfig = this.runTimeConfigService.getConfig('APIMConfig');
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authConfig.authMechanism !== 'oauth2-oidc') {
      return next.handle(req);
    } else {
      const APIMAuthURLs = [
        this.baseURLConfig.APIM.baseURL + this.APIMConfig.getAccessToken.endPoint,
        this.baseURLConfig.APIM.baseURL + this.APIMConfig.revokeAccessToken.endPoint
      ];
      // if the base url does not consists of APIM domain or is a APIM token URL, bypass adding APIM access token
      if (
        req.url.indexOf(new URL(this.baseURLConfig.APIM.baseURL).origin) === -1 ||
        APIMAuthURLs.includes(req.url) ||
        req.url.indexOf('?ping') > -1 ||
        req.url.indexOf('getTenantMetaData') > -1
      ) {
        return next.handle(req);
      }
      // Acquire APIM access token for this request, and attach as proper auth header.
      return from(
        this.authService.getAccessTokenAPIM().then(accessToken => {
          const authHeader = 'Bearer ' + accessToken;
          const tenantName: any = sessionStorage.getItem('tenant_name_state');
          return req.clone({
            setHeaders: {
              Authorization: authHeader,
              tenant_name: tenantName,
              'Cache-Control': 'no-cache',
              'X-Content-Type-Options': 'nosniff',
              'Content-Security-Policy': "default-src 'self'"
            }
          });
        })
      ).pipe(
        mergeMap(nextReq => next.handle(nextReq)),
        tap((ev: HttpEvent<any>) => {
          // if (ev instanceof HttpResponse) {
          //   console.log('processing response', ev);
          // }
        }),
        catchError(err => {
          if (err instanceof HttpErrorResponse) {
            // todo: Create and move logic to exception service
            let skipErrorToast: boolean;
            if (req.params instanceof CustomHttpParams) {
              if (req.params.customParams) {
                if (
                  req.params.customParams.skipInterceptorErrorForCodes &&
                  req.params.customParams.skipInterceptorErrorForCodes.indexOf(err.status) > -1
                ) {
                  skipErrorToast = true;
                }
              }
            }

            if (err && err.error && err.error.fault) {
              if (!skipErrorToast) {
                this.toastService.showToast(
                  err.error.fault.message ||
                    'lang.appShared.interceptors.loaderInterceptor.toastMessage.acessDeniedYouAreUnauthorized',
                  'toastError',
                  {
                    clearToasts: true
                  }
                );
              }

              // if (
              //   (err.status === 401 || err.status === 403) &&
              //   !skipErrorToast &&
              //   err.url.indexOf(environment.APIM.baseURL) > -1
              // ) {
              //   const navigationExtras: NavigationExtras = {
              //     state: {
              //       routedFromAPI: err.url
              //     }
              //   };
              //
              //   if (!this.popupService.getOpenComponentPopup(null, 'unauthorized-access-popup')) {
              //     // this.router.navigate(['auth/unauthorized'], navigationExtras);
              //     const popupInstance = this.popupService.showMessagePopup(
              //       'Access Denied',
              //       'You are unauthorized to access this page/resource!',
              //       {
              //         type: 'error'
              //       },
              //       {
              //         actionButton: { buttonLabel: 'Return' }
              //       },
              //       'unauthorized-access-popup'
              //     );
              //
              //     popupInstance.result.then(data => {
              //       // todo: Change this after role based access integration
              //       if (this.router.url.indexOf('/dashboard/home') === -1) {
              //         this.location.back();
              //       }
              //     });
              //   }
              // }
            }
          }

          return throwError(err);
        })
      );
    }
  }
}
